import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTrialResults } from 'store/getTrialResultsSlice';
import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import { trialResults } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const TrialResults = () => {
    const dispatch = useDispatch();
    const { fs_title, fs_view_button, fs_title_background, crops } =
        useSelector(state => state?.trialResults?.data?.data) || {};

    useEffect(() => {
        dispatch(fetchTrialResults());
    }, [dispatch]);

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            We showcase the results <br /> of our <img src={image} alt="decor" />
                            <em>research on different groups of plants</em>
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Here you can find <em>analyzes and conclusions</em> on the effectiveness of products in
                                increasing yields.
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={trialResults} />}>
                    <div className="box">
                        <ProductItems data={crops} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default TrialResults;
